import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
  useRef,
} from "react";
import { Grid, Card, CardContent, Typography } from "@mui/material";

import SamplingAndPackaging from "./SamplingAndPackaging";

import {
  fetchCarriersDataFromAPI,
  fetchFreightTermsDataFromAPI,
  fetchLayoutInformation,
} from "../../CommonFuntion/SchemaAPICalls";
import {
  VIPSDataServiceURL,
  requestOptions,
} from "../../Constants/GlobalConstant";
import { getUserSessionData } from "../../CommonFuntion/CheckSession";
import { getCustPoRegexPattern } from "./AdditionalInformationHelper";
import { sessionCache } from "../../CommonFuntion/sessionCache";

import CopyInstructionsButton from "./CopyInstructionsButton";
import MultilineTextField from "./MultilineTextField";
import DropdownField from "./DropdownField";
import CustomerPONumberField from "./CustomerPONumberField";
import DatePickerField from "./DatePickerField";
import SamplingAndPackagingField from "./SamplingAndPackagingField";
import LayoutApprovalSection from "./LayoutApprovalSection";
const AdditionalInformationComponent = forwardRef(
  (
    {
      user_id,
      // schema_id,
      store_grp,
      isInteralOrAdminUser = false,
      csvUplaodEnabled = false,
      divisionId,
      lockDates = false,
      setSelectedCarriersChild,
      setSelectedFreightTermsChild,
      setCustPoNumberChild,
      minimumDate,
      customerRequestDate,
      setCustomerRequestDate,
      requiredDate,
      SetRequiredDate,
      promiseDate,
      setPromiseDate,
      SpecialInstruction,
      setSpecialInstruction,
      PrinterNotes,
      SetPrinterNotes,
      VendorNotes,
      setVendorNotes,
      shippingInstruction,
      setShippingInstruction,
      orderLineInstructions,
      setOrderLineInstructions,
      retailerPurchaseOrderNo,
      setRetailerPurchaseOrderNo,
      shippingMark,
      setShippingMark,
      setSamplingAndPackagingCodeChild,
      tempArr,
      setLayoutApprovalChild,
      setOrderOnHoldChild,
      disableDateSelection,
      setCheckDuplicatePOChild,
      searchParams,
    },
    ref
  ) => {
    const [custPoRegex, setCustPoRegex] = useState("");
    useEffect(() => {
      try {
        const result = getCustPoRegexPattern(custPoRegex, store_grp);
        if (result && typeof result.then === "function") {
          result
            .then((pattern) => {
              setCustPoRegex(pattern);
            })
            .catch(() => {});
        } else if (typeof result === "string") {
          setCustPoRegex(result);
        }
      } catch (_) {}
    }, []);
    useImperativeHandle(ref, () => ({ validateForm: validateForm }));
    const [custorPoValidation, setCustorPoValidation] = useState({
      msg: "",
      invalid: false,
    });

    const [showPOAlert, setShowPOAlert] = useState({
      alertDescription: "",
      open: false,
      agreed: false,
    });
    const [customerRequestDateValidation, setCustomerRequestDateValidation] = useState({ msg: "", invalid: false });
    const [requiredDateValidation, setRequiredDateValidation] = useState({ msg: "", invalid: false });
    const [promiseDateValidation, setPromiseDateValidation] = useState({ msg: "", invalid: false });

    const [carriersData, setCarriersData] = useState([]);
    const [freightTermsData, setFreightTermsData] = useState([]);
    const [custPoNumber, setCustPoNumber] = useState("");

    const [samplingAndPackagingCode, setSamplingAndPackagingCode] =
      useState("");
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [customerOrderDate, setCustomerOrderDate] = useState(new Date());
    const [selectedCarriers, setSelectedCarriers] = useState(0);
    const [selectedFreightTerms, setSelectedFreightTerms] = useState("");
    const [layoutInformation, setLayoutInformation] = useState([]);
    const [layoutApproval, setLayoutApproval] = useState(false);
    const [orderOnHold, setOrderOnHold] = useState(false);

    const handleClosePopup = () => {
      setIsPopupOpen(false);
    };

    const handleSavePopup = (values) => {
      setSamplingAndPackagingCode(values);
      setSamplingAndPackagingCodeChild(values);
    };

   const handleCustPoNumberChange = (e) => {
    setCustorPoValidation({ msg: "", invalid: false });
    const raw = e.target.value;
    const invalidRe = new RegExp(custPoRegex, "gi");
    const cleaned = raw.replace(invalidRe, "");
    setCustPoNumber(cleaned);
    setCustPoNumberChild(cleaned);
  };
    const handleCarriersChange = (event) => {
      setSelectedCarriers(event.target.value);
      setSelectedCarriersChild(event.target.value);
    };
    const handleFreightTermsChange = (event) => {
      setSelectedFreightTerms(event.target.value);
      setSelectedFreightTermsChild(event.target.value);
    };
    const INVALID_SENTINEL = "0001-01-01T00:00:00";
    const isInvalidDateValue = (val) => {
      if (!val) return true;
      if (val === INVALID_SENTINEL) return true;
      const d = new Date(val);
      if (isNaN(d.getTime())) return true;
      // treat year < 1900 as invalid (covers year 0001)
      if (d.getFullYear() < 1900) return true;
      return false;
    };

    // helpers for date-only comparison
    const toDateOnlyKey = (val) => {
      if (!val) return null;
      const d = new Date(val);
      if (isNaN(d.getTime())) return null;
      return d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate(); // yyyymmdd numeric
    };
    const keyToDate = (key) => {
      if (!key) return null;
      const y = Math.floor(key / 10000);
      const m = Math.floor((key % 10000) / 100) - 1;
      const d = key % 100;
      return new Date(y, m, d);
    };
    const formatOriginalDate = (key) => {
      const d = keyToDate(key);
      return d ? d.toLocaleDateString() : "";
    };
    const isOriginalValid = (key) => key !== null && key !== undefined; // numeric yyyymmdd key

    // Blank out invalid dates coming from API so pickers show empty
    useEffect(() => {
      if (isInvalidDateValue(customerRequestDate)) setCustomerRequestDate(null);
      if (isInvalidDateValue(requiredDate)) SetRequiredDate(null);
      if (isInvalidDateValue(promiseDate)) setPromiseDate(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerRequestDate, requiredDate, promiseDate]);
    // refs to store first valid dates (immutable baselines) as numeric yyyymmdd keys
    const originalCustomerRequestDateRef = useRef(null);
    const originalRequiredDateRef = useRef(null);
    const originalPromiseDateRef = useRef(null);

    // When a valid date arrives for the first time, lock it as original
    useEffect(() => {
      if (!originalCustomerRequestDateRef.current && !isInvalidDateValue(customerRequestDate)) {
        originalCustomerRequestDateRef.current = toDateOnlyKey(customerRequestDate);
      }
      if (!originalRequiredDateRef.current && !isInvalidDateValue(requiredDate)) {
        originalRequiredDateRef.current = toDateOnlyKey(requiredDate);
      }
      if (!originalPromiseDateRef.current && !isInvalidDateValue(promiseDate)) {
        originalPromiseDateRef.current = toDateOnlyKey(promiseDate);
      }
    }, [customerRequestDate, requiredDate, promiseDate]);

    // Re-validate if user manually types an earlier date
    useEffect(() => {
      if (lockDates) return; // skip CRD earlier-date validation when locked
      const orig = originalCustomerRequestDateRef.current;
      if (orig && !isInvalidDateValue(customerRequestDate)) {
        const k = toDateOnlyKey(customerRequestDate);
        if (k < orig) setCustomerRequestDateValidation({ msg: `Cannot select a date earlier than original (${formatOriginalDate(orig)})`, invalid: true });
      }
    }, [customerRequestDate, lockDates]);
    useEffect(() => {
      if (lockDates) return; // skip earlier-date validation when locked/required
      const orig = originalRequiredDateRef.current;
      if (orig && !isInvalidDateValue(requiredDate)) {
        const k = toDateOnlyKey(requiredDate);
        if (k < orig) setRequiredDateValidation({ msg: `Cannot select a date earlier than original (${formatOriginalDate(orig)})`, invalid: true });
      }
    }, [requiredDate, lockDates]);
    useEffect(() => {
      if (lockDates) return; // skip PD earlier-date validation when locked
      const orig = originalPromiseDateRef.current;
      if (orig && !isInvalidDateValue(promiseDate)) {
        const k = toDateOnlyKey(promiseDate);
        if (k < orig) setPromiseDateValidation({ msg: `Cannot select a date earlier than original (${formatOriginalDate(orig)})`, invalid: true });
      }
    }, [promiseDate, lockDates]);

    const validateForm = () => {
      let inValidFlag = false;

      if (custPoNumber === "" && !csvUplaodEnabled) {
        setCustorPoValidation({
          msg: "Please Enter Customer PO Number",
          invalid: true,
        });
        inValidFlag = true;
      }
      if (!lockDates && isInvalidDateValue(customerRequestDate)) {
        setCustomerRequestDateValidation({ msg: "Please Enter Customer Request Date", invalid: true });
        inValidFlag = true;
      }
      if (isInvalidDateValue(requiredDate)) {
        setRequiredDateValidation({ msg: "Please Enter Required Date", invalid: true });
        inValidFlag = true;
      }
      if (!lockDates && isInvalidDateValue(promiseDate)) {
        setPromiseDateValidation({ msg: "Please Enter Promise Date", invalid: true });
        inValidFlag = true;
      }
      // Earlier-date checks (in case user bypassed onChange logic)
      if (!lockDates && originalCustomerRequestDateRef.current && !isInvalidDateValue(customerRequestDate) &&
          toDateOnlyKey(customerRequestDate) < originalCustomerRequestDateRef.current) {
        setCustomerRequestDateValidation({ msg: `Cannot select a date earlier than original (${formatOriginalDate(originalCustomerRequestDateRef.current)})`, invalid: true });
        inValidFlag = true;
      }
      if (!lockDates && originalRequiredDateRef.current && !isInvalidDateValue(requiredDate) &&
          toDateOnlyKey(requiredDate) < originalRequiredDateRef.current) {
        setRequiredDateValidation({ msg: `Cannot select a date earlier than original (${formatOriginalDate(originalRequiredDateRef.current)})`, invalid: true });
        inValidFlag = true;
      }
      if (!lockDates && originalPromiseDateRef.current && !isInvalidDateValue(promiseDate) &&
          toDateOnlyKey(promiseDate) < originalPromiseDateRef.current) {
        setPromiseDateValidation({ msg: `Cannot select a date earlier than original (${formatOriginalDate(originalPromiseDateRef.current)})`, invalid: true });
        inValidFlag = true;
      }
      return inValidFlag;
    };
    const CheckPoNumber = (event) => {
      var ponum = event.target.value;
      var storeGrp = store_grp;
      if (ponum.length > 0) {
        async function exampleFetch() {
          setCheckDuplicatePOChild(true);
          await fetch(
            `${VIPSDataServiceURL}` +
              `/Order/CustomerPODuplicateCheck?strDivisionID=${divisionId}&` +
              `strOrderID=${"''"}&` +
              `strStoreGrp=${storeGrp}&` +
              `strCustPONo=${ponum}`,
            requestOptions,
            { mode: "no-cors" }
          )
            .then((response) => response.json())
            .then((pocheck) => {
              setCheckDuplicatePOChild(false);
              if (pocheck == true) {
                if (custPoNumber != "") {
                  setShowPOAlert({
                    alertDescription:
                      "Customer Purchase Order Number:" +
                      " " +
                      event.target.value +
                      " " +
                      "already exists. Do you want to continue?",
                    open: true,
                  });
                  let final_data = pocheck;
                  return final_data;
                }
              }
            });
          // (error) => {}
        }
        (async () => {
          await exampleFetch();
        })();
      }
    };
    const handleTextFieldClick = () => {
      // Open the pop-up window when the TextField is clicked
      setIsPopupOpen(true);
    };
    const handleClearInput = () => {
      setSamplingAndPackagingCode("");
      setSamplingAndPackagingCodeChild("");
    };
    useEffect(() => {
        let firstPageID = JSON.parse(localStorage.getItem("firstPageID"))!==null? JSON.parse(localStorage.getItem("firstPageID")): searchParams.get("PageID");
      let jsonObjectId =searchParams.get("OCC") ? searchParams.get("PageID") : firstPageID
      try {
        const maybe = getUserSessionData(user_id, jsonObjectId);
        const handleData = (data2) => {
          if (!data2) return;
          for (var key in data2) {
            sessionCache.set(key, data2[key]);
          }
          const data = sessionCache.get(user_id + jsonObjectId + "checkoutForm") ?? null;
          if (data) {
            setCustPoNumber(data["custPoNumber"]);
            setCustPoNumberChild(data["custPoNumber"]);
            setSelectedCarriers(data["selectedCarriers"]);
            setSelectedCarriersChild(data["selectedCarriers"]);
            setSelectedFreightTerms(data["selectedFreightTerms"]);
            setSelectedFreightTermsChild(data["selectedFreightTerms"]);
            setSpecialInstruction(data["SpecialInstruction"]);
            SetPrinterNotes(data["PrinterNotes"]);
            setVendorNotes(data["VendorNotes"]);
            setShippingInstruction(data["shippingInstruction"]);
            setOrderLineInstructions(data["orderLineInstructions"]);
            setRetailerPurchaseOrderNo(data["retailerPurchaseOrderNo"]);
            setShippingMark(data["shippingMark"]);
            setSamplingAndPackagingCode(data["samplingAndPackagingCode"]);
            setSamplingAndPackagingCodeChild(data["samplingAndPackagingCode"]);
          }
        };
        if (maybe && typeof maybe.then === "function") {
          maybe.then(handleData).catch(() => {});
        } else {
          handleData(maybe);
        }
      } catch (_) {}
    }, []);
    useEffect(() => {
      try {
        const carriersMaybe = fetchCarriersDataFromAPI(divisionId);
        const setCarriers = (data) => setCarriersData(Array.isArray(data) ? data : []);
        if (carriersMaybe && typeof carriersMaybe.then === "function") {
          carriersMaybe.then(setCarriers).catch(() => setCarriers([]));
        } else {
          setCarriers(carriersMaybe);
        }
      } catch (_) {
        setCarriersData([]);
      }
      try {
        const freightMaybe = fetchFreightTermsDataFromAPI(divisionId);
        const setFreight = (data) => setFreightTermsData(Array.isArray(data) ? data : []);
        if (freightMaybe && typeof freightMaybe.then === "function") {
          freightMaybe.then(setFreight).catch(() => setFreight([]));
        } else {
          setFreight(freightMaybe);
        }
      } catch (_) {
        setFreightTermsData([]);
      }
    }, []);

    useEffect(() => {
      const promises = tempArr.map((x) => {
        try {
          const maybe = fetchLayoutInformation(x.ProductDesc, store_grp, divisionId);
          if (maybe && typeof maybe.then === "function") {
            return maybe.catch(() => null);
          }
          return Promise.resolve(maybe);
        } catch (_) {
          return Promise.resolve(null);
        }
      });

      Promise.all(promises).then((results) => {
        // Merge all responses: if ANY label requires layout, enable it
        const merged = results.reduce(
          (acc, data) => {
            if (!data) return acc;
            return {
              generateLayout: acc.generateLayout || !!data.generateLayout,
              defaultLayout: acc.defaultLayout || !!data.defaultLayout,
              defaultHold: acc.defaultHold || !!data.defaultHold,
              forceLayout: acc.forceLayout || !!data.forceLayout,
            };
          },
          { generateLayout: false, defaultLayout: false, defaultHold: false, forceLayout: false }
        );

        setLayoutInformation(merged);
        if (merged.forceLayout && merged.generateLayout) {
          setLayoutApproval(true);
          setLayoutApprovalChild(true);
          setOrderOnHold(true);
          setOrderOnHoldChild(true);
        } else {
          setLayoutApproval(merged.defaultLayout);
          setLayoutApprovalChild(merged.defaultLayout);
          setOrderOnHold(merged.defaultHold);
          setOrderOnHoldChild(merged.defaultHold);
        }
      });
    }, [tempArr]);
    useEffect(() => {
      if (showPOAlert.agreed == "false") {
        setCustPoNumber("");
        document.querySelector('[name="CustomerPONumber"]').focus();
      }
    }, [showPOAlert]);
    return (
      <Grid container item xs={12}>
        <Grid item xs>
          <Typography variant="h5">
            <b>Additional Information</b>
          </Typography>

          <Card variant="outlined">
            <CardContent>
              <Grid container spacing={2}>
                {isInteralOrAdminUser && (
                  <Grid item xs={12} sm={6} md={4}>
                    <CopyInstructionsButton />
                  </Grid>
                )}
                {!csvUplaodEnabled && (
                  <Grid item xs={12} sm={6} md={4}>
                    <CustomerPONumberField
                      custPoNumber={custPoNumber}
                      handleCustPoNumberChange={handleCustPoNumberChange}
                      CheckPoNumber={CheckPoNumber}
                      custorPoValidation={custorPoValidation}
                      showPOAlert={showPOAlert}
                      setShowPOAlert={setShowPOAlert}
                    />
                  </Grid>
                )}
                {isInteralOrAdminUser && (
                  <>
                    <Grid item xs={12} sm={6} md={4}>
                      <DropdownField
                        label="Select Carriers"
                        value={selectedCarriers}
                        onChange={handleCarriersChange}
                        options={carriersData}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <DropdownField
                        label="Select Freight Terms"
                        value={selectedFreightTerms}
                        onChange={handleFreightTermsChange}
                        options={freightTermsData}
                      />
                    </Grid>
                  </>
                )}

                {(lockDates
                  ? [
                      {
                        label: "Required Date",
                        value: requiredDate,
                        setValue: SetRequiredDate,
                        validation: requiredDateValidation,
                        clearValidation: () => setRequiredDateValidation({ msg: "", invalid: false }),
                        originalRef: originalRequiredDateRef,
                      },
                    ]
                  : [
                      {
                        label: "Customer Request Date",
                        value: customerRequestDate,
                        setValue: setCustomerRequestDate,
                        validation: customerRequestDateValidation,
                        clearValidation: () => setCustomerRequestDateValidation({ msg: "", invalid: false }),
                        originalRef: originalCustomerRequestDateRef,
                      },
                      {
                        label: "Required Date",
                        value: requiredDate,
                        setValue: SetRequiredDate,
                        validation: requiredDateValidation,
                        clearValidation: () => setRequiredDateValidation({ msg: "", invalid: false }),
                        originalRef: originalRequiredDateRef,
                      },
                      {
                        label: "Promise Date",
                        value: promiseDate,
                        setValue: setPromiseDate,
                        validation: promiseDateValidation,
                        clearValidation: () => setPromiseDateValidation({ msg: "", invalid: false }),
                        originalRef: originalPromiseDateRef,
                      },
                    ]).map(({ label, value, setValue, validation, clearValidation, originalRef }) => {
                  // NEW: set originalRef immediately if preloaded value present to avoid disable/enable flicker
                  if (!originalRef.current && value && !isInvalidDateValue(value)) {
                    originalRef.current = toDateOnlyKey(value);
                  }
                  const displayValue = isInvalidDateValue(value) ? null : value;
                  const origKey = originalRef.current;
                  const hasValidOriginal = isOriginalValid(origKey);
                  const originalMinDate = hasValidOriginal ? keyToDate(origKey) : null;
                  return (
                    <Grid key={label} item xs={12} sm={6} md={4}>
                      <DatePickerField
                        label={label}
                        value={displayValue}
                        onChange={(newValue) => {
                          if (!newValue) {
                            clearValidation();
                            setValue(null);
                            return;
                          }
                          if (hasValidOriginal) {
                            const newKey = toDateOnlyKey(newValue);
                            if (newKey < origKey) {
                              const msg = `Cannot select a date earlier than original (${formatOriginalDate(origKey)})`;
                              if (label === "Customer Request Date") {
                                setCustomerRequestDateValidation({ msg, invalid: true });
                              } else if (label === "Required Date") {
                                setRequiredDateValidation({ msg, invalid: true });
                              } else if (label === "Promise Date") {
                                setPromiseDateValidation({ msg, invalid: true });
                              }
                              // keep entered value to show error
                              setValue(newValue);
                              return;
                            }
                          }
                          clearValidation();
                          setValue(newValue);
                          // Set original if first valid and not yet stored
                          if (!hasValidOriginal) {
                            const firstKey = toDateOnlyKey(newValue);
                            if (firstKey) originalRef.current = firstKey;
                          }
                        }}
                        minDate={
                          lockDates
                            ? null
                            : originalMinDate ||
                              (isInvalidDateValue(minimumDate)
                                ? new Date()
                                : new Date(minimumDate))
                        }
                        // CHANGED: remove hasValidOriginal from disable logic to stop flicker
                        disabled={!hasValidOriginal || disableDateSelection || lockDates}
                        error={!lockDates && validation.invalid}
                        errorMsg={validation.msg}
                      />
                    </Grid>
                  );
                })}
             {[
  {
    id: "SpecialInstruction",
    label: lockDates ? "Customer Reference" : "Special Instruction",
    value: SpecialInstruction,
    onChange: setSpecialInstruction,
  },
  {
    id: "PrinterNotes",
    label: "Printer Notes",
    value: PrinterNotes,
    onChange: SetPrinterNotes,
  },
  {
    id: "VendorNotes",
    label: "Vendor Notes",
    value: VendorNotes,
    onChange: setVendorNotes,
  },
  {
    id: "ShippingInstruction",
    label: "Shipping Instructions",
    value: shippingInstruction,
    onChange: setShippingInstruction,
  },
  {
    id: "OrderLineInstructions",
    label: "Order Line Instructions",
    value: orderLineInstructions,
    onChange: setOrderLineInstructions,
  },
  {
    id: "RetailerPurchaseOrderNo",
    label: "Retailer Purchase Order No.",
    value: retailerPurchaseOrderNo,
    onChange: setRetailerPurchaseOrderNo,
    inputProps: {
      style: { color: "black", fontWeight: "normal" },
      maxLength: 20,
    },
  },
  {
    id: "ShippingMark",
    label: "Shipping Mark",
    value: shippingMark,
    onChange: setShippingMark,
  },
].map(({ id, label, value, onChange, inputProps }) => (
  <Grid key={id} item xs={12} sm={6} md={4}>
    <MultilineTextField
      id={id}
      label={label}
      value={value}
      onChange={onChange}
      {...(inputProps ? { inputProps } : {})}
    />
  </Grid>
))}
                {isInteralOrAdminUser && (
                  <Grid item xs={12} sm={6} md={4}>
                    <SamplingAndPackagingField
                      samplingAndPackagingCode={samplingAndPackagingCode}
                      setSamplingAndPackagingCode={setSamplingAndPackagingCode}
                      setSamplingAndPackagingCodeChild={
                        setSamplingAndPackagingCodeChild
                      }
                      handleTextFieldClick={handleTextFieldClick}
                      handleClearInput={handleClearInput}
                      isPopupOpen={isPopupOpen}
                      SamplingAndPackaging={SamplingAndPackaging}
                      handleClosePopup={handleClosePopup}
                      handleSavePopup={handleSavePopup}
                    />
                  </Grid>
                )}
                <LayoutApprovalSection
                  layoutInformation={layoutInformation}
                  layoutApproval={layoutApproval}
                  setLayoutApproval={setLayoutApproval}
                  setOrderOnHold={setOrderOnHold}
                  setLayoutApprovalChild={setLayoutApprovalChild}
                  setOrderOnHoldChild={setOrderOnHoldChild}
                  orderOnHold={orderOnHold}
                  isInteralOrAdminUser={isInteralOrAdminUser}
                />
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    );
  }
);

export default AdditionalInformationComponent;
